import type { ButtonHTMLAttributes } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


/**
 * link reads as a link in running text. muted is for secondary
 * controls that should not draw the eye, such as a debug toggle.
 */
export type TextButtonTone = "link" | "muted";

const TONE_CLASSES: Record<TextButtonTone, string> = {
    link: "text-link",
    muted: "text-subtle hover:text-body active:text-strong",
};


interface TextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    tone?: TextButtonTone;
}


/**
 * A button drawn as text, for an action that sits in a sentence or a
 * row of values. For navigation, use a link.
 */
export function TextButton({ tone = "link", className, ...props }: TextButtonProps) {
    return (
        <button
            type="button"
            {...props}
            className={cn(
                "inline cursor-pointer hover:underline",
                "disabled:cursor-not-allowed disabled:no-underline disabled:opacity-50",
                TONE_CLASSES[tone],
                className ?? null,
            )} />
    );
}
